import React, { useEffect, useState } from 'react'
import "../../styles/profileStyles/myProfileTipps.css";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    ResponsiveContainer
} from "recharts";
import { useParams } from 'react-router-dom';
import BeatLoader from 'react-spinners/BeatLoader';


export default function MyProfileTipps() {
    const [cardDatas, setCardDatas] = useState(null);

    const { username: targetUsername } = useParams();

    // const cardDatas = {
    //     success: true,

    //     chartData: [
    //         { date: "Week 01", rate: 45 },
    //         { date: "Week 02", rate: 60 },
    //         { date: "Week 03", rate: 52 },
    //         { date: "Week 04", rate: 70 },
    //         { date: "Week 05", rate: 30 },
    //         { date: "Week 06", rate: 80 }
    //     ],

    //     tippTypeSuccessRate: [
    //         {
    //             type: "goal_over_under",
    //             label: "Gólszám over/under",
    //             rate: 62,
    //             total: 45
    //         },
    //         {
    //             type: "both_team_score",
    //             label: "BTTS",
    //             rate: 48,
    //             total: 30
    //         },
    //         {
    //             type: "home_x_away",
    //             label: "1X2 Kimenetel",
    //             rate: 27,
    //             total: 22
    //         },
    //         {
    //             type: "cards_over_under",
    //             label: "Lapok száma",
    //             rate: 75,
    //             total: 18
    //         }
    //     ],

    //     leagueStats: [
    //         {
    //             league: "Premier League Anglia Nagyon Hosszú Név",
    //             rate: 65,
    //             total: 34
    //         },
    //         {
    //             league: "La Liga",
    //             rate: 55,
    //             total: 20
    //         },
    //         {
    //             league: "Serie A Olaszország",
    //             rate: 28,
    //             total: 18
    //         },
    //         {
    //             league: "Bundesliga",
    //             rate: 48,
    //             total: 25
    //         },
    //         {
    //             league: "Ligue 1 Franciaország Extra Hosszú",
    //             rate: 75,
    //             total: 40
    //         }
    //     ]
    // };

    useEffect(() => {
        fetch(`https://focifanatik.hu/api/profile_API/profileTipps.php?username=${targetUsername}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.success) {
                    setCardDatas(data);
                }
            })
            .catch((err) => console.error("Hiba a lekéréskor:", err));
    }, []);


    if (!cardDatas) {
        return (
            <>
                <div className='loading-bg-profileBar'><BeatLoader color="white" size={55} /></div>
                <div className='loading-bg-content'></div>
            </>
        );
    }
    return (
        <>

            <div className='myProfileTippsPage-topProfileBar'>

                <h1><i class="bi bi-bookmarks"></i></h1>
                <h1>Tippjáték</h1>

            </div>

            {/* TARTALOM */}
            <div className='myProfileTippsPage-content'>
                <div className='myProfileTippsStatsGrid'>

                    <div className='myProfileTippsCardOne'>
                        <h3>Találati arányom</h3>

                        <div className='myProfileTippsCardOne-graph'>
                            <ResponsiveContainer width="100%" height={250}>
                                <LineChart data={cardDatas.chartData}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="date" />
                                    <YAxis />
                                    <Tooltip />
                                    <Line
                                        type="monotone"
                                        dataKey="rate"
                                        stroke="oklch(68% 0.24475 141.51)"
                                        strokeWidth={3}
                                    />
                                </LineChart>
                            </ResponsiveContainer>
                        </div>

                        <div>
                            {/* IDE JÖN MAJD VALAMI AZ ALJARA */}
                        </div>

                    </div>

                    <div className='myProfileTippsCardTwo'>
                        <h3>Fogadási tipusok találati arányai</h3>

                        <div className='myProfileTippsCardTwoDetailsWrapper'>

                            {cardDatas.tippTypeSuccessRate.map((data) => (
                                <div className='myProfileTippsCardTwoDetails'>
                                    <h4>{data.label}</h4>
                                    <p className={`${data.rate > 50 ? "myProfileTippsStatBoxDetailsGreen" : data.rate < 30 ? "myProfileTippsStatBoxDetailsRed" : "myProfileTippsStatBoxDetailsYellow"}`}>
                                        {data.rate}%
                                    </p>
                                </div>
                            ))}

                        </div>

                    </div>

                    <div className='myProfileTippsCardThree'>
                        <h3>Ligák szerinti találati arány</h3>

                        <div className='myProfileTippsStatBoxWrapper'>
                            {cardDatas.leagueStats.map((stat) => (

                                <div className='myProfileTippsStatBox'>

                                    <div className='myProfileTippsStatBoxDetails'>
                                        <h4>{stat.league.slice(0, 15)}</h4>
                                        <p className={`${stat.rate > 50 ? "myProfileTippsStatBoxDetailsGreen" : stat.rate < 30 ? "myProfileTippsStatBoxDetailsRed" : "myProfileTippsStatBoxDetailsYellow"}`}>
                                            {stat.rate}%
                                        </p>
                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}
